// Procedūras — weight-loss & anti-cellulite treatments rendered in the second section.
// Same item shape as masazas.js: { title, intro?, bullets?, outro?, prices: [{ label, value }] }
const proceduras = [
  {
    title: 'Mehāniskā limfodrenāža jeb t. s. "gaisa zābaki"',
    intro:
      'Masāža ar mainīgu gaisa spiedienu, kā rezultātā uzlabojas asinsrite un limfas plūsma. Šī procedūra palīdz ārstēt celulītu, novērst dažādas izcelsmes tūskas, likvidēt venozās atteces traucējumus. Tā ir viena no pamatprocedūrām figūras korekcijai un cīņai ar celulītu, kas aktivizē vielmaiņu ādas taukšūnās. Limfodrenāža mazina nogurumu, veicina muskuļu atslābināšanos, palielina ādas elastību, uzlabo sejas krāsu, novērš dažādas izcelsmes tūskas, veicina grumbu izlīdzināšanu. Masāža ar mainīgu gaisa spiedienu ne vien patīkami relaksē, bet arī uzlabo asinsriti un limfas plūsmu, kā arī palīdz izvadīt no organisma kaitīgos vielmaiņas galaproduktus – toksīnus. Ļoti efektīva procedūra pie "smagu" un pietūkušu kāju problēmas.',
    prices: [
      { label: 'Limfodrenāža visam ķermenim', value: '20 €' },
      { label: 'Limfodrenāža (kājas+vēders)', value: '18 €' },
    ],
  },
  {
    title: 'Elektrolipolīze + ultraskaņas terapija (sonoforēze)',
    intro:
      'Lokāli šķeļ liekos taukaudu sakopojumus samazinot ķermeņa problēmvietu apjomu un ārstē ieilgušu celulītu, vienlaicīgi tonizējot ādu. Ši ir viena no celulīta ārstēšanas pamatprocedūrām, kas ietver tauku depozītu likvidēšanu, ādas nostiprināšanu, ādas tonizēšanu. Ultraskaņa spēj visdziļāk ietikt tauku slānī un tā stimulē tauku metabolismu un enzīmus. Kopumā ultraskaņas mērķis ir cīņa ar vājiem ļenganiem saistaudiem uz dibena, vēdera un gurniem. Būtiska tās priekšrocība ir arī speciālo preparātu ievadīšana audos ar ultraskaņas palīdzību (sonofrēze). Tiek izkustināti tauku šūnu sakopojumi, veicinot aktīvu limfas atteci. Ultraskaņas terapija efektīvi novērš grumbuļainos veidojumus uz augšstilbiem.',
    prices: [
      { label: 'Ultraskaņas terapija', value: '25 €' },
      { label: 'Ultraskaņas terapija + vakuummasāža', value: '30 €' },
    ],
  },
  {
    title: 'Klasiskā (stikla kolbu) vakuummasāža',
    intro:
      'Vakuummasāža ir veids kā cīnīties ar celulītu, samazināt apjomus un padarīt ādu tvirtāku. Vakuummasāža būtībā ir tāda pati masāža, kā visas citas masāžas, tikai tai ir cita tehnoloģija. Vakuummasāžas aparāts piesūcas pie ādas kā banka, tāpēc šāda masāža ir daudz dziļāka, līdz ar to tauku slāni var pacelt un kārtīgi izmasēt. Stikla kausiņā vacuums iesūc problēmzonas ādas laukumu, notiek intensīva un dziļa masāža, kas uzlabo vielmaiņu, asinsriti, celulīta šūnu membrānas kļūst caurlaidīgākas līdz ar to no šūnām labāk izvadās šlakviels, šūnas samazinās apjomā un āda kļūst gludāka. Masāžas rezultātā ādā pastiprināti veidojas elastīns un kalogēns, kas nodrošina ādas elastību.',
    prices: [
      { label: 'Vēders + muguras vakuummasāža', value: '30 €' },
      { label: 'Vakuummasāža kājām (kājas+sēžas daļa)', value: '30 €' },
      { label: 'Vakuummasāža visam ķermenim', value: '30 €' },
      { label: 'Vakuummasāža mugura + rokas', value: '30 €' },
    ],
  },
  {
    title: 'Impulsveida vakuummasāža sēžas daļai ’’Brazīliešu dibentiņš’’ + vakuummasāža',
    prices: [
      { label: 'Impulsveida vakuummasāža sēžas daļai', value: '25 €' },
      { label: 'Impulsveida vakuummasāža sēžas daļai + vakuumma kolbu masāža', value: '30 €' },
    ],
  },
];

export default proceduras;
